import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { IStore } from '../interfaces/StoreTypes';
import { useConfigurationSections } from './useConfiguration';

/**
 * Hook to access PPV events configuration
 *
 * ✅ This replaces Redux generalConfiguration.ppvEventConfig access
 * Provides a consistent way to access PPV events throughout the app
 */
export const usePPVEvents = () => {
    // For now, we'll use the existing Redux state but wrap it in a React Query-like interface
    // This can be migrated to a proper API call later if needed
    const ppvEventConfig = useSelector((state: IStore) => state?.generalConfiguration?.ppvEventConfig || null);

    return {
        data: ppvEventConfig,
        isLoading: false, // Since it's from Redux, it's always loaded
        isError: false,
        error: null,
    };
};

/**
 * Hook to access promotions configuration
 *
 * ✅ This replaces Redux generalConfiguration.promotions access
 * ✅ Now uses React Query configuration instead of Redux
 */
export const usePromotions = () => {
    const { promotions } = useConfigurationSections();

    return {
        data: promotions || [],
        isLoading: false,
        isError: false,
        error: null,
    };
};

/**
 * Hook to access upgraded modal state
 *
 * ✅ This replaces Redux generalConfiguration.showUpgradedModal access
 */
export const useUpgradedModalState = () => {
    const showUpgradedModal = useSelector((state: IStore) => state?.generalConfiguration?.showUpgradedModal || false);

    return {
        showUpgradedModal,
        isLoading: false,
        isError: false,
        error: null,
    };
};

export const useGuestRedirectModalState = () => {
    const showGuestRedirectModal = useSelector(
        (state: IStore) => state?.generalConfiguration?.showGuestRedirectModal || false
    );

    return {
        showGuestRedirectModal,
        isLoading: false,
        isError: false,
        error: null,
    };
};
